const urlPrefix = process.env.REACT_APP_URL_PREFIX || '';
const appPrefix = urlPrefix + '/popup-editor';

export const makeRoute = {
    home: () => appPrefix,
    create: () => appPrefix + '/new',
    edit: (id: number | string) => appPrefix + `/edit/${id}`,
};